import React from 'react';
import { Select } from 'antd';

const { Option } = Select;

const UOM1 = ({ value, onChange, placeholder = "Select Unit", className = "control-Select mb-3", disabled }) => {
  return (
    <Select
      disabled={disabled}
      className={className}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      allowClear
    >
      <Option value="BOX">BOX</Option>
      <Option value="PALLET">PALLET</Option>
      <Option value="CONTAINER">CONTAINER</Option>
    </Select>
  );
};

export default UOM1;
